module.exports = __webpack_public_path__ + "static/joel-cf365033f2db63e0c08a9fd74e4ff4b2.jpg";